const RestaurantListLoader = ({ length }: { length: number }) => (
  <div role='alert' aria-busy='true' aria-live='polite'>
    {Array.from({ length }, (_, index) => (
      <div key={index} className='mt-3 h-24 w-full animate-pulse rounded-md bg-pink-100 dark:bg-black' />
    ))}
  </div>
);

export default RestaurantListLoader;
